import { PopoverButton } from "./popover-button";
import { toolboxFlowsTriggerButtons } from "./constants";
import JourneySlotHandleDialog from "../../../components/journey-slot-handle-dialog";
import { useState, useEffect, useContext } from "react";
import { getAgentAction } from "../../../services/prompt-ai";
import { WorkflowCanvasContext } from "../../../contexts/WorkflowCanvasContextProvider";
import TextToWorkflowModel from "../../text-to-workflow";
import { GEN_AI_TEXT_TO_WF, GEN_AI_TEXT_TO_WF_EDIT } from "../../../consts/gen-ai-consts";
import { connect } from "react-redux";
import { HiOutlineSquares2X2 } from "react-icons/hi2";

function Toolbox({ appId, journeyId, onSlotsUpdated, stmSlotCreateRequestMessage }) {
  const workflowContext = useContext(WorkflowCanvasContext);
  const [currentEvent, setCurrentEvent] = useState();
  const [actionConfig, setActionConfig] = useState({ name: '...' });

  const onEventTrigger = event => {
    console.log('onEventTrigger', event)
    if (event === 'save') {
      handleSave();
      return;
    }
    setCurrentEvent(event)
  }

  const [dataLoadingState, setDataLoading] = useState({
    processing: false,
    success: false,
    failed: false,
    message: null,
  });

  const updateDataLoadingState = (processing, success, failed, message) => {
    setDataLoading({ processing, success, failed, message });
  };

  const fetchActionConfig = async () => {
    updateDataLoadingState(true, false, false);
    const resp = await getAgentAction(appId, journeyId);
    if (resp) {
      setActionConfig(resp)
    }
    updateDataLoadingState(false, true, false);
  }

  const onDragStart = (event, nodeData) => {
    workflowContext.onDragStart(event, nodeData)
  }

  const handleSave = () => {
    // Call the save functionality from the workflow context
    if (workflowContext && workflowContext.saveWorkflow) {
      workflowContext.saveWorkflow(false);
    }
  }

  useEffect(() => {
    if (journeyId) {
      fetchActionConfig();
    }
  }, [journeyId]);

  return (
    <div className="flex flex-wrap items-center gap-3 border-b border-gray-200 bg-gray-50/60 px-4 py-2.5">
      {/* Workflow identity */}
      <div className="flex min-w-0 flex-1 items-center gap-2.5">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary text-white">
          <HiOutlineSquares2X2 className="h-4 w-4" />
        </span>
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold capitalize text-gray-900">
            {actionConfig.name}
          </p>
          <p className="text-[11px] text-gray-400">Workflow</p>
        </div>
      </div>

      {/* Node palette */}
      <menu className="m-0 flex items-center gap-0.5 rounded-xl border border-gray-200 bg-white p-1 shadow-sm">
        {toolboxFlowsTriggerButtons.map((button, index) => {
          return <PopoverButton key={index} option={button} eventTrigger={onEventTrigger} onDragStart={onDragStart} />;
        })}
      </menu>

      {/*
        Reserved gutter for the document controls (save / undo / redo / auto save)
        that WorkflowCanvas floats over the right of this row.
      */}
      <div className="flex-1 min-w-[19rem]" aria-hidden="true" />

      {(currentEvent === 'variable' || stmSlotCreateRequestMessage) &&
        <JourneySlotHandleDialog
          appId={appId}
          journeyId={journeyId}
          onSlotsUpdated={onSlotsUpdated}
          stmSlotCreateRequestMessage={stmSlotCreateRequestMessage}
          onContainerClose={() => {
            setCurrentEvent(null);
          }}
        />
      }

      {(actionConfig.id && (currentEvent === GEN_AI_TEXT_TO_WF || currentEvent === GEN_AI_TEXT_TO_WF_EDIT)) &&
        <TextToWorkflowModel
          journeyId={actionConfig.id}
          event={currentEvent}
          onCompletion={() => { setCurrentEvent(null) }}
          onCancel={() => { setCurrentEvent(null) }} />
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    stmSlotCreateRequestMessage: state.stmSlotCreateRequestMessage
  };
};

export default connect(mapStateToProps)(Toolbox);
